import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import LoadingSpinner from '../components/common/LoadingSpinner';
import { UserRole } from '../types/user';

const HomePage: React.FC = () => {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // لا تقم بأي شيء إذا كانت بيانات المستخدم لا تزال قيد التحميل
    if (isLoading) {
      return;
    }

    if (user) {
      switch (user.role) {
        case UserRole.ADMIN:
          navigate('/admin/dashboard'); // أو /admin/dashboard
          break;
        case UserRole.SUBSCRIBER:
          navigate('/subscriber/dashboard');
          break;
        case UserRole.TRAINEE:
          navigate('/trainee/dashboard'); // للمستقبل
          break;
        case UserRole.LAWYER:
          navigate('/lawyer/dashboard'); // للمستقبل
          break;
        default:
          // في حالة وجود دور غير معروف، أرسله إلى صفحة تسجيل الدخول
          navigate('/directory');
      }
    } else {
      // إذا لم يكن هناك مستخدم، أرسله إلى صفحة تسجيل الدخول
      navigate('/directory');
    }
  }, [user, isLoading, navigate]);

  // عرض شاشة تحميل أثناء عملية إعادة التوجيه
  return <LoadingSpinner />;
};

export default HomePage;
